var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.accessSystem !== null)?[_c('AccessSystemDisplay',{attrs:{"accessSystem":_vm.accessSystem,"event":_vm.event,"editing":false}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }